<!-- Spinner -->
<div class="loader" *ngIf="(loading | async) && !router.url.includes('/app-auth-callback')">
    <mat-spinner class="spinner"></mat-spinner>
</div>

<app-header></app-header>
<app-navbar #nav></app-navbar>

<!-- Access Denied -->
<app-access-denied *ngIf="authService?.getRoles()?.length == 0 && !isWorkflowSummaryView && !isWorkflowExecutionHistoryView && !router.url.includes('/hil-test-results-upload') && !router.url.includes('/dashboard')"></app-access-denied>

<!-- Content -->
<div class="page-container" [class.workflow-prerequisite-container]="isWorkflowPrerequisiteView"
    [class.update-summary-container]="isWorkflowSummaryView || isWorkflowExecutionHistoryView">
    <router-outlet></router-outlet>
</div>

<!-- Product tour -->
<app-guided-tour id="productTourId"></app-guided-tour>